"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapLayerSwitcherOverlays = void 0;
var strongly_typed_events_1 = require("strongly-typed-events");
var IMapEvents_1 = require("./events/IMapEvents");
var interaction_1 = require("ol/interaction");
var control_1 = require("ol/control");
var View_1 = require("ol/View");
var Feature_1 = require("ol/Feature");
var Point_1 = require("ol/geom/Point");
var Polygon_1 = require("ol/geom/Polygon");
var LineString_1 = require("ol/geom/LineString");
var Vector_1 = require("ol/layer/Vector");
var Vector_2 = require("ol/source/Vector");
var Map_1 = require("ol/Map");
var MapLayerSwitcherOverlays = /** @class */ (function () {
    function MapLayerSwitcherOverlays(_map, _mapStore, _allLayers, _mappingTextPack) {
        var _this = this;
        this._map = _map;
        this._mapStore = _mapStore;
        this._allLayers = _allLayers;
        this._mappingTextPack = _mappingTextPack;
        this._initialised = false;
        this._overlaysInitialised = false;
        //events
        this._onOverlayChanged = new strongly_typed_events_1.SimpleEventDispatcher();
        this._onLayerAction = new strongly_typed_events_1.SimpleEventDispatcher();
        this.init = function () {
            if (!_this._initialised) {
                _this._mapContainer = $("#".concat(_this._map.olMap.getTargetElement().parentElement.id));
                _this._map.onZoomChanged.subscribe(_this.onZoomChanged);
                _this._map.onVectorLayerGroupLoaded.subscribe(_this.onLayerGroupLoaded);
                _this._layerGroupWarningIconLastLoad = {};
                _this._initialised = true;
            }
        };
        this.addOverlays = function () {
            var self = _this;
            if (!self._overlaysInitialised) {
                if (_this._allLayers !== null) {
                    _this._allLayers.layerGroupCollections.forEach(function (grpCol) {
                        var addLayersCallback = function (container) {
                            //each layer group collection
                            var ul = $("<ul>", { "class": "esdm-layer-switcher" });
                            container.append(ul);
                            var _loop_1 = function (grp) {
                                if (grp.displayInLayerSwitcher === true) {
                                    var li = $("<li>");
                                    var grpId = "OverlayLayer" + grp.ref;
                                    var input = $("<input>", { id: grpId, "type": "checkbox", "checked": grp.visibleOnLoad || grp.isVisible(self._mapStore) });
                                    input.change(function () {
                                        self.onOverlayVisibiltyChanged(grp, $(this).prop("checked"));
                                    });
                                    li.append(input);
                                    ul.append(li);
                                    if (_this._allLayers.isVectorLayerGroup(grp)) {
                                        //VECTOR
                                        var legendContainerId = "layer_switcher_legend_container_".concat(grp.ref);
                                        var legendContainer = $("<div/>", { id: legendContainerId, class: "legendContainer" });
                                        var legendMapId = "layer_switcher_legend_map_".concat(grp.ref);
                                        li.append($("<label>", { for: grpId, html: grp.displayName }));
                                        if (grp.displayInLegend === true) {
                                            var legendMapElement = $("<div/>", { id: legendMapId, class: "legendMap" });
                                            legendContainer.append(legendMapElement);
                                            li.append(legendContainer);
                                            //must do the map after the element has been added to the dom
                                            self.addLegendMap(legendMapId, grp);
                                        }
                                        //put all the icons in a container so we align them
                                        var iconContainer = $("<div/>", { class: "legendIconContainer" });
                                        legendContainer.append(iconContainer);
                                        self.addZoomToBounds(grp, iconContainer);
                                        var layerDisabledId = "layer_switcher_disabled_".concat(grp.ref);
                                        iconContainer.append("<span id=".concat(layerDisabledId, " class=\"layer-warning\" style='display:none'>\n                                                      <i class=\"far fa-eye-slash\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"").concat(_this._mappingTextPack.layerNotVisibleAtScale, "\"></i>\n                                                    </span>"));
                                        var layerDataLimitId = "layer_switcher_limit_".concat(grp.ref);
                                        iconContainer.append("<span id=".concat(layerDataLimitId, " class=\"layer-warning\" style='display:none'>\n                                                      <i class=\"fas fa-exclamation-circle\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"").concat(_this._mappingTextPack.zoomInToSeeMore, "\"></i>\n                                                   </span>"));
                                    }
                                    else {
                                        //WMS
                                        var layerDisabledId = "layer_switcher_disabled_".concat(grp.ref);
                                        li.append($("<label>", { for: grpId, html: grp.displayName }));
                                        li.append("<span id=".concat(layerDisabledId, " class=\"layer-warning\" style='display:none'><i class=\"far fa-eye-slash\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"").concat(_this._mappingTextPack.layerNotVisibleAtScale, "\"></i></span>"));
                                        if (grp.displayInLegend === true) {
                                            // jk - unfortunate requirement from LHLP to make sure that no stray HTML has been appended to displayName 
                                            var format = /[<>]/;
                                            if (format.test(grp.displayName)) {
                                                li.append("<img class=\"legendGraphic\" src=\"".concat(self.getLegendGraphic(grp), "\" alt=\"Legend graphic for layer ").concat(grp.ref, "\"></img>"));
                                            }
                                            else {
                                                li.append("<img class=\"legendGraphic\" src=\"".concat(self.getLegendGraphic(grp), "\" alt=\"Legend graphic for layer ").concat(grp.displayName, "\"></img>"));
                                            }
                                        }
                                    }
                                }
                            };
                            for (var _i = 0, _a = grpCol.layerGroups; _i < _a.length; _i++) {
                                var grp = _a[_i];
                                _loop_1(grp);
                            }
                        };
                        self.getLayerGroupUlContainer(grpCol, addLayersCallback);
                    });
                }
                self._overlaysInitialised = true;
            }
            self.setDisabledLegendIcon(self._map.getZoom());
            self.addMapLayerInfoIcon();
            window.setTimeout(function () {
                $('[data-bs-toggle="tooltip"]').tooltip();
            }, 250);
        };
        this.getLegendGraphic = function (lyrGrp) {
            var layerSource = lyrGrp.layers[0].olWmsLayer.getSource();
            var styleName = "";
            var params = {
                request: "GetLegendGraphic",
                version: "1.3.0",
                format: "image/png",
                layer: layerSource.getParams()["LAYERS"],
                service: "WMS",
                sld_version: "1.1.0",
                transparent: "true"
            };
            lyrGrp.layers.forEach(function (l) {
                if (l.visible && l.styleName) {
                    styleName = l.styleName;
                }
            });
            if (styleName) {
                params["style"] = styleName;
            }
            var queryString = Object.keys(params).map(function (key) {
                return key + '=' + encodeURIComponent(params[key]);
            }).join('&');
            return "".concat(layerSource.getUrl(), "?").concat(queryString);
        };
        //uses a callback to add the layers & legends
        //because the legends for the wfs are OL maps they don't render unless they are actually visible, 
        //meaning we sometimes have to delay the adding of the layers until the parent element is visible
        this.getLayerGroupUlContainer = function (layerGroupCollection, addLayersCallback) {
            var self = _this;
            var panel = $("#panelOverlays");
            if (layerGroupCollection.useAccordion) {
                var mapState = self._mapStore.getMapInfo();
                var accordionExpanded = false;
                if (layerGroupCollection.alwaysExpandedOnLoad) {
                    //always expand
                    accordionExpanded = true;
                }
                else if (mapState.accordions && typeof mapState.accordions[layerGroupCollection.ref] != "undefined") {
                    //use map state
                    accordionExpanded = mapState.accordions[layerGroupCollection.ref];
                }
                else {
                    //no map state, use first load
                    accordionExpanded = layerGroupCollection.expandedOnFirstLoad;
                }
                //Use accordion
                var accordion = $("<div>", { "class": "accordion esdm-layer-switcher-accordion", "id": "esdm-layer-switcher-accordion-".concat(layerGroupCollection.ref) });
                panel.append(accordion);
                var headerId = "heading_".concat(layerGroupCollection.ref);
                var collapseId_1 = "collapse_".concat(layerGroupCollection.ref);
                accordion.append("\n                      <div class=\"card\">\n                          <div class=\"card-header ".concat(!accordionExpanded ? "collapsed" : "", "\" id=\"").concat(headerId, "\" data-bs-toggle=\"collapse\" data-bs-target=\"#").concat(collapseId_1, "\">\n                              <button class=\"btn btn-link\" type=\"button\">\n                                ").concat(layerGroupCollection.name, "\n                              </button>\n                        </div>\n                        <div id=\"").concat(collapseId_1, "\" class=\"collapse ").concat(accordionExpanded ? "show" : "", "\" aria-labelledby=\"").concat(headerId, "\" data-bs-parent=\"#esdm-layer-switcher-accordion-").concat(layerGroupCollection.ref, "\">\n                            <div class=\"card-body\"></div>\n                        </div>\n                      </div>"));
                var cardBody_1 = $("#".concat(collapseId_1, " > .card-body"));
                if (accordionExpanded) {
                    //expanded by default so we can just add the layers
                    addLayersCallback(cardBody_1);
                }
                else {
                    //add the layers
                    $("#".concat(collapseId_1)).one('shown.bs.collapse', function () {
                        console.log("show layers - ".concat(collapseId_1));
                        addLayersCallback(cardBody_1);
                    });
                }
                //add handler to maintain accordion state
                $("#".concat(collapseId_1)).on('show.bs.collapse', function () {
                    self._mapStore.onAccordionVisibiltyChanged(layerGroupCollection.ref, true);
                });
                $("#".concat(collapseId_1)).on('hide.bs.collapse', function () {
                    self._mapStore.onAccordionVisibiltyChanged(layerGroupCollection.ref, false);
                });
            }
            else {
                //add the layers straight away
                addLayersCallback(panel);
            }
        };
        this.addZoomToBounds = function (grp, elementToAppendTo) {
            if (grp.allowZoomToLoadedDataBounds === true) {
                var self_1 = _this;
                var zoomToBoundsId = "layer_switcher_zoom_".concat(grp.ref);
                var zoomToBounds = $("<span id=".concat(zoomToBoundsId, " class=\"layer-zoom-to-bounds\" data-group-ref='").concat(grp.ref, "' style='display:block'>\n                                    <i class=\"fas fa-expand\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"").concat(_this._mappingTextPack.zoomToLayer, "\"></i>\n                                 </span>"));
                elementToAppendTo.append(zoomToBounds);
                if (!grp.isVisible(self_1._mapStore)) {
                    self_1.setZoomToBounds(grp, false);
                }
                zoomToBounds.click(function () {
                    self_1.onLayerActionZoomToBounds(grp);
                });
            }
        };
        this.setZoomToBounds = function (grp, visible) {
            if (grp.allowZoomToLoadedDataBounds === true) {
                var ele = $("#layer_switcher_zoom_".concat(grp.ref));
                if (visible) {
                    ele.show();
                }
                else {
                    ele.hide();
                }
            }
        };
        this.addLegendMap = function (legendMapId, layerGrp) {
            var newMap = new Map_1.default({
                target: legendMapId,
                controls: (0, control_1.defaults)({
                    attribution: false,
                    rotate: false,
                    zoom: false
                }),
                interactions: (0, interaction_1.defaults)({
                    altShiftDragRotate: false,
                    dragPan: false,
                    doubleClickZoom: false,
                    keyboard: false,
                    mouseWheelZoom: false,
                    shiftDragZoom: false,
                    pinchZoom: false,
                    pinchRotate: false
                }),
                view: new View_1.default({
                    center: [80, 0],
                    zoom: 16
                })
            });
            var f = [];
            var pos = 1;
            if (layerGrp.layerLegend.point === true) {
                f.push(new Feature_1.default({
                    geometry: new Point_1.default([25, 0])
                }));
                pos += 1;
            }
            if (layerGrp.layerLegend.polygon === true) {
                var x = void 0;
                if (pos === 1) {
                    x = 10;
                }
                else {
                    x = 66;
                }
                f.push(new Feature_1.default({
                    geometry: new Polygon_1.default([[[x, -20], [x, 20], [x + 40, 20], [x + 40, -20], [x, -20]]])
                }));
                pos += 1;
            }
            if (layerGrp.layerLegend.line === true) {
                var x = void 0;
                if (pos === 1) {
                    x = 10;
                }
                else if (pos === 2) {
                    x = 70;
                }
                else {
                    //pos==3
                    x = 130;
                }
                f.push(new Feature_1.default({
                    geometry: new LineString_1.default([[x, 0], [x + 40, 0]])
                }));
            }
            var vl = new Vector_1.default({
                source: new Vector_2.default({
                    features: f
                }),
                style: layerGrp.style
            });
            newMap.addLayer(vl);
        };
        this.onOverlayVisibiltyChanged = function (grp, visible) {
            var self = _this;
            var zoom = self._map.olMap.getView().getZoom();
            self._mapStore.onLayerVisibiltyChanged(grp.ref, visible);
            //set the visibilty of all layers with the same (group) name                                             
            grp.setLayersVisibility(zoom, self._mapStore);
            self.setDisabledLegendIcon(self._map.getZoom());
            if (self._allLayers.isVectorLayerGroup(grp)) {
                self.setZoomToBounds(grp, visible);
            }
            var showWarning = false;
            if (visible === true) {
                //revert to previous setting?
                showWarning = self._layerGroupWarningIconLastLoad[grp.ref] || false;
            }
            self.showLayerWarningIcon(grp.ref, showWarning);
            self._onOverlayChanged.dispatch({
                layerGroupRef: grp.ref,
                visible: visible,
                recordType: grp.layerType
            });
            console.log("Layer ".concat(grp.ref, " visible=").concat(visible ? "yes" : "no"));
        };
        this.onLayerActionZoomToBounds = function (group) {
            _this._onLayerAction.dispatch({
                layerGroup: group,
                action: IMapEvents_1.LayerActionEvent.zoomToDataBounds
            });
        };
        this.onLayerGroupLoaded = function (args) {
            _this.showLayerWarningIcon(args.layerGroup.ref, args.maxFeatureCountReached);
            _this._layerGroupWarningIconLastLoad[args.layerGroup.ref] = args.maxFeatureCountReached;
        };
        this.onZoomChanged = function (args) {
            console.log("Map layer switcher zoom level changed: ".concat(args.zoomLevel));
            _this.resetWarningLegendIcon();
            _this.setDisabledLegendIcon(args.zoomLevel);
        };
        this.resetWarningLegendIcon = function () {
            if (_this._allLayers !== null) {
                for (var _i = 0, _a = _this._allLayers.vectorLayerGroups; _i < _a.length; _i++) {
                    var grp = _a[_i];
                    _this.showLayerWarningIcon(grp.ref, false);
                }
            }
            _this.setMapInfoLegendIcon();
        };
        this.setMapInfoLegendIcon = function () {
            //if any icons are visible then show the icon
            $(".layer-warning").each(function (index, element) {
                //if any icons are visible then show the message
                if ($("#".concat(element.id)).is(':visible')) {
                    //wasn't showing properly first time in
                    window.setTimeout(function () {
                        $("#layer-info").show();
                    }, 10);
                    return;
                }
            });
            $("#layer-info").hide();
        };
        this.setDisabledLegendIcon = function (zoomLevel) {
            if (_this._allLayers !== null) {
                for (var _i = 0, _a = _this._allLayers.layerGroupCollections; _i < _a.length; _i++) {
                    var grpColl = _a[_i];
                    for (var _b = 0, _c = grpColl.layerGroups; _b < _c.length; _b++) {
                        var grp = _c[_b];
                        var show = (grp.displayInLayerSwitcher === true && grp.isVisible(_this._mapStore) && grp.isDisabled(_this._mapStore, zoomLevel));
                        _this.showLayerDisabledIcon(grp.ref, show);
                    }
                }
            }
            _this.setMapInfoLegendIcon();
        };
        this.init();
    }
    Object.defineProperty(MapLayerSwitcherOverlays.prototype, "onOverlayChanged", {
        get: function () {
            return this._onOverlayChanged.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MapLayerSwitcherOverlays.prototype, "onLayerAction", {
        get: function () {
            return this._onLayerAction.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    MapLayerSwitcherOverlays.prototype.addMapLayerInfoIcon = function () {
        var infoHtml = "\n                <div id=\"layer-info\" class=\"layerswitcher-layer-info\" style=\"display:none\">\n                    <div class=\"layerswitcher-layer-info-inner\">\n                        <i class=\"far fa-eye-slash\" data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" title=\"".concat(this._mappingTextPack.notAllDataIsVisible, "\"></i>\n                    </div>                    \n                </div>\n         ");
        this._mapContainer.append(infoHtml);
    };
    MapLayerSwitcherOverlays.prototype.showLayerDisabledIcon = function (groupRef, show) {
        var layerDisabledId = "#layer_switcher_disabled_".concat(groupRef);
        if (show === true) {
            $(layerDisabledId).show();
        }
        else {
            $(layerDisabledId).hide();
        }
        this.setMapInfoLegendIcon();
    };
    MapLayerSwitcherOverlays.prototype.showLayerWarningIcon = function (groupRef, show) {
        var layerDataLimitId = "#layer_switcher_limit_".concat(groupRef);
        if (show === true) {
            $(layerDataLimitId).show();
        }
        else {
            $(layerDataLimitId).hide();
        }
        this.setMapInfoLegendIcon();
    };
    return MapLayerSwitcherOverlays;
}());
exports.MapLayerSwitcherOverlays = MapLayerSwitcherOverlays;
//# sourceMappingURL=MapLayerSwitcherOverlays.js.map